
(() => {
  const targets = document.querySelectorAll('.viewer, .footer-workbench');

  targets.forEach((target) => {
    let rect = target.getBoundingClientRect();
    let currentX = 0;
    let targetX = 0;
    let rafId = 0;

    const render = () => {
      currentX += (targetX - currentX) * 0.28;
      if (Math.abs(targetX - currentX) < 0.1) currentX = targetX;

      const width = Math.max(rect.width, 1);
      target.style.setProperty('--scan-x', `${currentX}px`);
      target.style.setProperty('--scan-ratio', String(currentX / width));

      if (Math.abs(targetX - currentX) >= 0.1) {
        rafId = requestAnimationFrame(render);
      } else {
        rafId = 0;
      }
    };

    const queueRender = () => {
      if (!rafId) rafId = requestAnimationFrame(render);
    };

    const updateTarget = (event) => {
      rect = target.getBoundingClientRect();
      targetX = Math.max(0, Math.min(rect.width, event.clientX - rect.left));
      queueRender();
    };

    target.addEventListener('pointerenter', (event) => {
      target.classList.add('scan-active');
      updateTarget(event);
    }, { passive: true });
    target.addEventListener('pointermove', updateTarget, { passive: true });
    target.addEventListener('pointerleave', () => {
      target.classList.remove('scan-active');
      targetX = 0;
      queueRender();
    }, { passive: true });

    window.addEventListener('resize', () => {
      rect = target.getBoundingClientRect();
      currentX = Math.min(currentX, rect.width);
      targetX = Math.min(targetX, rect.width);
      queueRender();
    }, { passive: true });
  });
})();
